import React, { createContext, useContext, useState, useEffect } from "react";

export const translations = {
  nl: {
    nav: { home: "Home", reviews: "Reviews", contact: "Contact", admin: "Beheer" },
    hero: {
      kicker: "Privédocent · Schoolvakken & Nederlands als taal",
      title: "Persoonlijke bijles, op maat voor iedereen",
      subtitle:
        "Persoonlijke begeleiding voor basisschool en middelbare school, én Nederlands als taal. Geduldig, gestructureerd — in het Nederlands, Russisch of Engels.",
      cta_reviews: "Lees reviews",
      cta_contact: "Neem contact op",
      badge: "Les in NL, RU & EN",
    },
    about: {
      title: "Over mij",
      name: "Learn with Devid",
      body:
        "Ik ben een privédocent, geboren in Nederland, en ik spreek vloeiend Nederlands, Russisch en Engels. Hierdoor kan ik lessen en uitleg geven in alle drie de talen, afhankelijk van wat de leerling nodig heeft. Nederlands is mijn moedertaal en geef ik ook als vak, inclusief grammatica; Russisch en Engels gebruik ik als voertaal tijdens de les — ik geef dus geen bijles in de grammatica van die talen. Ik begeleid leerlingen van de basisschool en de middelbare school in uiteenlopende vakken, met een geduldige, duidelijke en gestructureerde aanpak.\n\nMet ongeveer 6 jaar leservaring heb ik gewerkt met leerlingen van verschillende leeftijden en niveaus. Daarnaast heb ik ervaring met het geven van Nederlands vanaf nul aan zowel kinderen als volwassenen.\n\nLesgeven is voor mij meer dan alleen het uitleggen van de lesstof. Ik neem mijn verantwoordelijkheid voor iedere leerling serieus en bereid mijn lessen zorgvuldig voor. Ik geloof dat iedere leerling kan groeien met de juiste begeleiding, geduld en een persoonlijke aanpak. Daarom probeer ik niet alleen kennis over te dragen, maar ook zelfvertrouwen en motivatie mee te geven. Ik vind het belangrijk dat leerlingen zich op hun gemak voelen, vragen durven stellen en stap voor stap vooruitgang boeken. Het geeft mij veel voldoening om te zien dat een leerling de stof begrijpt, betere resultaten behaalt en met meer plezier en vertrouwen leert.",
    },
    subjects: {
      title: "Vakken",
      intro: "Ik geef bijles in alle basisschoolvakken en bijna alle middelbare schoolvakken.",
      primary: "Basisschool",
      primary_desc: "Alle vakken: rekenen, taal, begrijpend lezen, spelling en meer.",
      secondary: "Middelbare school",
      secondary_desc: "Bijna alle vakken, waaronder wiskunde, natuurkunde, biologie, economie en aardrijkskunde.",
      dutch: "Nederlands als taal",
      dutch_desc: "Nederlands leren vanaf nul — voor kinderen én volwassenen, van de basis tot vloeiend spreken.",
      note: "Let op: geen scheikunde en geen vreemde talen (behalve Nederlands en Engels).",
    },
    pricing: {
      title: "Tarief",
      kicker: "Eén eenvoudig, vast tarief",
      excl: "excl. btw",
      incl: "incl. btw",
      per_hour: "per uur",
      business: "Wordt het op een bedrijf gezet? Dan zonder btw.",
      cta: "Plan een les",
      policy_title: "Annuleren",
      policy: "Lessen moeten minimaal 24 uur van tevoren worden geannuleerd. Gebeurt dat niet, dan wordt de les geteld alsof deze gegeven is. Eén keer is geen probleem — we zijn allemaal mensen — zolang er geen misbruik van wordt gemaakt.",
      consult_title: "Gratis kennismaking",
      consult: "Een gratis kennismakings- en planningsgesprek van 30 minuten.",
    },
    reviewsSnippet: {
      title: "Wat mensen van de lessen vinden",
      empty: "Nog geen reviews. Wees de eerste!",
      all: "Bekijk alle reviews",
    },
    contact: {
      title: "Contact",
      subtitle: "Vragen of een les inplannen? Stuur een bericht.",
      name: "Naam",
      email: "E-mail",
      message: "Bericht",
      send: "Versturen",
      sending: "Versturen...",
      success: "Bedankt! Je bericht is verstuurd.",
      error: "Er ging iets mis. Probeer het opnieuw.",
      or_email: "Of mail direct naar",
    },
    reviewsPage: {
      title: "Reviews",
      subtitle: "Ervaringen van ouders en leerlingen.",
      leave: "Schrijf een review",
      empty: "Er zijn nog geen goedgekeurde reviews.",
      form_title: "Schrijf een review",
      form_desc: "Je review wordt eerst gecontroleerd voordat hij zichtbaar wordt.",
      your_name: "Je naam",
      rating: "Beoordeling",
      your_review: "Je review",
      your_class: "Klas / vak",
      your_age: "Leeftijd",
      optional: "optioneel",
      submit: "Versturen",
      submitting: "Versturen...",
      success: "Bedankt! Je review wordt beoordeeld.",
      error: "Er ging iets mis. Probeer het opnieuw.",
      age_error: "Voer een geldige leeftijd in (0–100).",
      translate: "Vertalen",
      show_original: "Toon origineel",
      translate_error: "Vertalen mislukt. Probeer het later opnieuw.",
    },
    admin: {
      login_title: "Beheer login",
      email: "E-mail",
      password: "Wachtwoord",
      login: "Inloggen",
      logging_in: "Inloggen...",
      login_error: "Onjuiste e-mail of wachtwoord.",
      dashboard: "Reviews beheren",
      logout: "Uitloggen",
      tab_pending: "In afwachting",
      tab_approved: "Goedgekeurd",
      tab_messages: "Berichten",
      approve: "Goedkeuren",
      reject: "Afwijzen",
      delete: "Verwijderen",
      edit: "Bewerken",
      save: "Opslaan",
      cancel: "Annuleren",
      edit_title: "Review bewerken",
      no_pending: "Geen reviews in afwachting.",
      no_approved: "Nog geen goedgekeurde reviews.",
      no_messages: "Nog geen berichten.",
    },
    footer: { rights: "Alle rechten voorbehouden.", tagline: "Privédocent · lessen in NL, RU & EN" },
  },
  ru: {
    nav: { home: "Главная", reviews: "Отзывы", contact: "Контакты", admin: "Админ" },
    hero: {
      kicker: "Частный репетитор · Нидерландский и русский",
      title: "Индивидуальные занятия, подобранные под каждого",
      subtitle:
        "Индивидуальные занятия для начальной и средней школы. Терпеливо, структурированно, на нидерландском или русском языке.",
      cta_reviews: "Читать отзывы",
      cta_contact: "Связаться",
      badge: "Занятия на NL и RU",
    },
    about: {
      title: "Обо мне",
      name: "Learn with Devid",
      body:
        "Я частный репетитор, родился в Нидерландах, и свободно владею нидерландским, русским и английским. Благодаря этому я могу вести занятия и объяснять материал на всех трёх языках — в зависимости от того, что нужно ученику. Нидерландский — мой родной язык, и я преподаю его как предмет, включая грамматику; русский и английский я использую как язык общения на занятиях, но не преподаю грамматику этих языков. Я занимаюсь с учениками начальной и средней школы по самым разным предметам, применяя терпеливый, понятный и структурированный подход.\n\nИмея около 6 лет опыта преподавания, я работал с учениками разного возраста и уровня. Кроме того, у меня есть опыт обучения нидерландскому языку с нуля как детей, так и взрослых.\n\nПреподавание для меня — это больше, чем просто объяснение материала. Я серьёзно отношусь к своей ответственности за каждого ученика и тщательно готовлюсь к занятиям. Я верю, что каждый ученик может расти при правильном сопровождении, терпении и индивидуальном подходе. Поэтому я стараюсь передавать не только знания, но и уверенность и мотивацию. Для меня важно, чтобы ученики чувствовали себя комфортно, не боялись задавать вопросы и шаг за шагом добивались успехов. Мне приносит большое удовлетворение видеть, как ученик понимает материал, достигает лучших результатов и учится с большим удовольствием и уверенностью.",
    },
    subjects: {
      title: "Предметы",
      intro: "Я преподаю все предметы начальной школы и почти все предметы средней школы.",
      primary: "Начальная школа",
      primary_desc: "Все предметы: математика, язык, чтение, орфография и другое.",
      secondary: "Средняя школа",
      secondary_desc: "Почти все предметы, включая математику, физику, биологию, экономику и географию.",
      dutch: "Нидерландский язык",
      dutch_desc: "Изучение нидерландского с нуля — для детей и взрослых, от основ до свободного общения.",
      note: "Обратите внимание: без химии и без иностранных языков (кроме нидерландского и английского).",
    },
    pricing: {
      title: "Стоимость",
      kicker: "Одна простая фиксированная цена",
      excl: "без НДС",
      incl: "с НДС",
      per_hour: "за час",
      business: "Оформление на компанию — без НДС.",
      cta: "Записаться на занятие",
      policy_title: "Отмена",
      policy: "Занятие необходимо отменить минимум за 24 часа. Если этого не сделать, занятие засчитывается как проведённое. Один раз — не проблема, мы все люди, — при условии, что этим не злоупотребляют.",
      consult_title: "Бесплатная консультация",
      consult: "Бесплатная ознакомительная и планировочная встреча — 30 минут.",
    },
    reviewsSnippet: {
      title: "Что думают о занятиях",
      empty: "Пока нет отзывов. Будьте первым!",
      all: "Смотреть все отзывы",
    },
    contact: {
      title: "Контакты",
      subtitle: "Есть вопросы или хотите записаться? Напишите мне.",
      name: "Имя",
      email: "Эл. почта",
      message: "Сообщение",
      send: "Отправить",
      sending: "Отправка...",
      success: "Спасибо! Ваше сообщение отправлено.",
      error: "Что-то пошло не так. Попробуйте снова.",
      or_email: "Или напишите напрямую на",
    },
    reviewsPage: {
      title: "Отзывы",
      subtitle: "Опыт родителей и учеников.",
      leave: "Оставить отзыв",
      empty: "Пока нет одобренных отзывов.",
      form_title: "Оставить отзыв",
      form_desc: "Ваш отзыв сначала проверяется, прежде чем стать видимым.",
      your_name: "Ваше имя",
      rating: "Оценка",
      your_review: "Ваш отзыв",
      your_class: "Класс / предмет",
      your_age: "Возраст",
      optional: "необязательно",
      submit: "Отправить",
      submitting: "Отправка...",
      success: "Спасибо! Ваш отзыв на проверке.",
      error: "Что-то пошло не так. Попробуйте снова.",
      age_error: "Введите корректный возраст (0–100).",
      translate: "Перевести",
      show_original: "Показать оригинал",
      translate_error: "Не удалось перевести. Попробуйте позже.",
    },
    admin: {
      login_title: "Вход в админку",
      email: "Эл. почта",
      password: "Пароль",
      login: "Войти",
      logging_in: "Вход...",
      login_error: "Неверная почта или пароль.",
      dashboard: "Управление отзывами",
      logout: "Выйти",
      tab_pending: "На проверке",
      tab_approved: "Одобренные",
      tab_messages: "Сообщения",
      approve: "Одобрить",
      reject: "Отклонить",
      delete: "Удалить",
      no_pending: "Нет отзывов на проверке.",
      no_approved: "Пока нет одобренных отзывов.",
      no_messages: "Пока нет сообщений.",
    },
    footer: { rights: "Все права защищены.", tagline: "Частный репетитор · занятия на NL, RU и EN" },
  },
  en: {
    nav: { home: "Home", reviews: "Reviews", contact: "Contact", admin: "Admin" },
    hero: {
      kicker: "Private tutor · School subjects & Dutch language",
      title: "Personal tutoring, tailored to everyone",
      subtitle:
        "Personal guidance for primary and secondary school, plus Dutch as a language. Patient and structured — in Dutch, Russian or English.",
      cta_reviews: "Read reviews",
      cta_contact: "Get in touch",
      badge: "Lessons in NL, RU & EN",
    },
    about: {
      title: "About me",
      name: "Learn with Devid",
      body:
        "I am a private tutor, born in the Netherlands, and I am fluent in Dutch, Russian and English. This means I can give lessons and explanations in all three languages, depending on what the student needs. Dutch is my native language and I also teach it as a subject, including grammar; Russian and English I use as languages of instruction during lessons, so I do not tutor the grammar of those languages. I support primary and secondary school students across a wide range of subjects, with a patient, clear and structured approach.\n\nWith around 6 years of teaching experience, I have worked with students of different ages and levels. I also have experience teaching Dutch from scratch to both children and adults.\n\nTeaching, to me, is more than simply explaining the material. I take my responsibility for every student seriously and prepare my lessons carefully. I believe that every student can grow with the right guidance, patience and a personal approach. That is why I try not only to pass on knowledge, but also to build confidence and motivation. I find it important that students feel at ease, dare to ask questions and make progress step by step. It gives me great satisfaction to see a student understand the material, achieve better results, and learn with more enjoyment and confidence.",
    },
    subjects: {
      title: "Subjects",
      intro: "I tutor all primary school subjects and almost all secondary school subjects.",
      primary: "Primary school",
      primary_desc: "All subjects: maths, language, reading comprehension, spelling and more.",
      secondary: "Secondary school",
      secondary_desc: "Almost all subjects, including maths, physics, biology, economics and geography.",
      dutch: "Dutch language",
      dutch_desc: "Learning Dutch from scratch — for children and adults, from the basics to fluent speaking.",
      note: "Please note: no chemistry and no foreign languages (except Dutch & English).",
    },
    pricing: {
      title: "Rate",
      kicker: "One simple, flat rate",
      excl: "excl. VAT",
      incl: "incl. VAT",
      per_hour: "per hour",
      business: "Billed to a company? Then without VAT.",
      cta: "Book a lesson",
      policy_title: "Cancellation",
      policy: "Lessons must be cancelled at least 24 hours in advance. If that doesn't happen, the lesson counts as if it was given. One time is fine — we're all human — as long as it isn't taken advantage of.",
      consult_title: "Free consultation",
      consult: "A free 30-minute introductory and planning talk.",
    },
    reviewsSnippet: {
      title: "What people think about the lessons",
      empty: "No reviews yet. Be the first!",
      all: "View all reviews",
    },
    contact: {
      title: "Contact",
      subtitle: "Questions or want to book a lesson? Send a message.",
      name: "Name",
      email: "Email",
      message: "Message",
      send: "Send",
      sending: "Sending...",
      success: "Thank you! Your message has been sent.",
      error: "Something went wrong. Please try again.",
      or_email: "Or email directly to",
    },
    reviewsPage: {
      title: "Reviews",
      subtitle: "Experiences from parents and students.",
      leave: "Write a review",
      empty: "There are no approved reviews yet.",
      form_title: "Write a review",
      form_desc: "Your review will be checked before it becomes visible.",
      your_name: "Your name",
      rating: "Rating",
      your_review: "Your review",
      your_class: "Class / subject",
      your_age: "Age",
      optional: "optional",
      submit: "Submit",
      submitting: "Submitting...",
      success: "Thank you! Your review is being reviewed.",
      error: "Something went wrong. Please try again.",
      age_error: "Please enter a valid age (0–100).",
      translate: "Translate",
      show_original: "Show original",
      translate_error: "Translation failed. Please try again later.",
    },
    admin: {
      login_title: "Admin login",
      email: "Email",
      password: "Password",
      login: "Log in",
      logging_in: "Logging in...",
      login_error: "Incorrect email or password.",
      dashboard: "Manage reviews",
      logout: "Log out",
      tab_pending: "Pending",
      tab_approved: "Approved",
      tab_messages: "Messages",
      approve: "Approve",
      reject: "Reject",
      delete: "Delete",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      edit_title: "Edit review",
      no_pending: "No reviews pending.",
      no_approved: "No approved reviews yet.",
      no_messages: "No messages yet.",
    },
    footer: { rights: "All rights reserved.", tagline: "Private tutor · lessons in NL, RU & EN" },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "nl");
  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
